import { useMemo, useState } from "react";

const GOLD     = "#C9A96E";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
const BORDER   = "#E7E1D8";
const SOFT_BG  = "#F7F5F2";
const WHITE    = "#FFFFFF";

const SITUATIONS = [
  {
    id: "trop-cher",
    titre: "C'est trop cher",
    etape: "Proposition contractuelle",
    risque: "Élevé",
    principe: "Ne jamais se défendre en détaillant le prix. Le prix est le résultat d'une analyse, pas une négociation.",
    reponseCourte: "Le niveau d'honoraires de YOMA DESIGN reflète le niveau de complexité et de risque de votre projet. Ce calcul est le résultat d'une analyse rigoureuse réalisée lors du dossier stratégique.",
    siInsiste: "Je comprends que le montant puisse surprendre. Si le cadrage financier ne correspond pas à vos attentes actuelles, nous pouvons en rester là sans aucune obligation de votre côté.",
    neJamaisDire: ["Je comprends, on peut peut-être regarder ce qu'on peut faire.", "C'est mon meilleur prix.", "On peut étaler différemment."],
  },
  {
    id: "concurrents-moins-cher",
    titre: "Vos concurrents proposent moins cher",
    etape: "Proposition contractuelle",
    risque: "Moyen",
    principe: "Ne jamais valider le concurrent comme référence. Recentrer sur le cadre, pas sur la comparaison.",
    reponseCourte: "C'est possible. Les structures qui interviennent sur ce marché ont des modèles, des niveaux d'engagement et des architectures contractuelles très différents. YOMA DESIGN propose un cadre précis — juridiquement structuré, financièrement tracé, opérationnellement documenté.",
    siInsiste: "Notre cadre est défini par notre méthode et notre niveau d'engagement. Nous ne nous positionnons pas sur une logique de comparaison tarifaire simple.",
    neJamaisDire: ["Qui vous a proposé ça ?", "Qu'est-ce qu'ils font exactement ?"],
  },
  {
    id: "pourquoi-800",
    titre: "Pourquoi payer 800 € juste pour un dossier ?",
    etape: "Dossier stratégique",
    risque: "Élevé",
    principe: "Le dossier stratégique est un livrable à part entière. Celui qui négocie cette étape négociera la suite.",
    reponseCourte: "Le dossier stratégique n'est pas une réunion de découverte. C'est une analyse complète — faisabilité, cadrage budgétaire réaliste, identification des risques, cartographie administrative. C'est un livrable écrit qui a une valeur indépendante de la suite.",
    siInsiste: "Nous avons fait le choix de ne pas offrir de consultations gratuites. Un projet immobilier représente plusieurs centaines de milliers d'euros. L'investissement initial est proportionné.",
    neJamaisDire: ["On peut le faire exceptionnellement gratuitement.", "On vous le déduira forcément derrière.", "C'est juste une formalité."],
  },
  {
    id: "commencer-avant-paiement",
    titre: "On commence et je règle dès que le financement est bouclé",
    etape: "Signature",
    risque: "Critique",
    principe: "Aucun démarrage avant encaissement. Le projet n'existe pas avant paiement.",
    reponseCourte: "YOMA DESIGN ne démarre aucune mission avant encaissement du premier versement contractuel. Ce principe protège les deux parties.",
    siInsiste: "Dès que le financement est confirmé et le premier versement effectué, nous ouvrons le dossier dans les 48 heures. En attendant, le dossier reste en attente.",
    neJamaisDire: ["On peut déjà avancer un peu.", "On commence et vous paierez après.", "Je vous fais confiance."],
  },
  {
    id: "reduire-perimetre",
    titre: "Et si on réduit le périmètre pour baisser le prix ?",
    etape: "Proposition contractuelle",
    risque: "Élevé",
    principe: "Le périmètre YOMA est cohérent. Le réduire ne réduit pas les risques, il les transfère.",
    reponseCourte: "Réduire le périmètre ne réduit pas les risques — cela les transfère vers vous. Ce n'est pas une formule que YOMA DESIGN propose.",
    siInsiste: "La mission est un ensemble cohérent. Il n'y a pas de version allégée compatible avec les standards de YOMA DESIGN.",
    neJamaisDire: ["On peut retirer quelques éléments.", "On peut faire une version light.", "On peut simplifier le suivi."],
  },
  {
    id: "exception-ami",
    titre: "Un ami m'a dit que vous faisiez une exception pour lui",
    etape: "Proposition contractuelle",
    risque: "Moyen",
    principe: "Aucune exception tarifaire. La constance protège l'autorité du modèle.",
    reponseCourte: "YOMA DESIGN applique les mêmes conditions à tous ses projets. Les honoraires sont calculés selon une grille interne fondée sur la complexité et le risque.",
    siInsiste: "Nos conditions ne varient pas selon les relations personnelles, mais selon la structure réelle du projet.",
    neJamaisDire: ["Oui mais votre cas est spécial.", "On peut voir ce qu'on peut faire pour vous."],
  },
  {
    id: "proposition-expiree",
    titre: "Le client disparaît puis revient en disant que c'est trop cher",
    etape: "Proposition contractuelle",
    risque: "Moyen",
    principe: "On ne renégocie pas rétroactivement. On revient à la proposition inchangée.",
    reponseCourte: "La proposition est valable 15 jours à compter de sa date d'émission. Si vous souhaitez y donner suite, les conditions restent identiques.",
    siInsiste: "Nous reprenons sur la base de la proposition initiale, sans modification du cadrage financier.",
    neJamaisDire: ["Pourquoi avez-vous disparu ?", "On peut peut-être revoir le prix."],
  },
  {
    id: "sans-dossier-strategique",
    titre: "On peut signer sans le dossier stratégique ?",
    etape: "Dossier stratégique",
    risque: "Élevé",
    principe: "La confiance n'autorise jamais à court-circuiter le process.",
    reponseCourte: "Le dossier stratégique n'est pas une formalité — c'est l'outil qui nous permet de construire une proposition contractuelle solide et réaliste.",
    siInsiste: "C'est précisément parce que le projet doit être sérieux que cette étape ne peut pas être sautée.",
    neJamaisDire: ["Exceptionnellement, on peut passer dessus.", "Oui, on verra ça plus tard."],
  },
  {
    id: "retirer-mandat-financier",
    titre: "On peut enlever le mandat financier ?",
    etape: "Signature / contractualisation",
    risque: "Critique",
    principe: "Retirer le mandat financier détruit l'architecture contractuelle et la traçabilité.",
    reponseCourte: "Le mandat financier fait partie intégrante de l'architecture contractuelle. YOMA DESIGN n'intervient pas sur des projets sans cette architecture.",
    siInsiste: "Sans mandat financier, nous sortons du cadre de fonctionnement YOMA. Nous ne poursuivons pas dans cette configuration.",
    neJamaisDire: ["On peut peut-être faire sans.", "Vous pouvez payer directement le constructeur."],
  },
  {
    id: "ajuster-en-cours",
    titre: "On signe, mais on ajuste en cours de route",
    etape: "Signature / contractualisation",
    risque: "Élevé",
    principe: "Toute évolution de périmètre doit passer par un avenant écrit.",
    reponseCourte: "Toute évolution de périmètre fera l'objet d'un avenant écrit, validé par les deux parties.",
    siInsiste: "Nous ne fonctionnons jamais sur une base floue ou révisable oralement en cours de mission.",
    neJamaisDire: ["On verra plus tard.", "On s'adaptera au fil de l'eau."],
  },
  {
    id: "client-charismatique",
    titre: "On va faire ça entre nous, sans formalités",
    etape: "Signature / pilotage",
    risque: "Critique",
    principe: "Plus le projet est important, plus le cadre doit être formel.",
    reponseCourte: "La formalisation protège la relation. Plus un projet est important, plus le cadre doit être précis.",
    siInsiste: "La qualité de la relation ne remplace jamais la rigueur contractuelle. Elle la rend encore plus nécessaire.",
    neJamaisDire: ["Oui, pas besoin d'être si formel.", "Entre nous, on peut simplifier."],
  },
];

const RISQUE_CONFIG = {
  Critique: { bg: "#FDEDEC", color: "#C0392B", border: "#F2C4C0", icon: "•" },
  Élevé:    { bg: "#FEF9EE", color: "#B7770D", border: "#F0DEB4", icon: "•" },
  Moyen:    { bg: "#EEF4FD", color: "#2E6DB4", border: "#C5D9F2", icon: "•" },
};

export default function NegotiationResponsesPage() {
  const [search,     setSearch]     = useState("");
  const [selectedId, setSelectedId] = useState("trop-cher");
  const [filterEtape, setFilterEtape] = useState("toutes");
  const [copied,     setCopied]     = useState("");

  const etapes = useMemo(() => [...new Set(SITUATIONS.map(s => s.etape))], []);

  const filtered = useMemo(() => SITUATIONS.filter(s => {
    const matchSearch = s.titre.toLowerCase().includes(search.toLowerCase()) ||
      s.reponseCourte.toLowerCase().includes(search.toLowerCase());
    const matchEtape = filterEtape === "toutes" || s.etape === filterEtape;
    return matchSearch && matchEtape;
  }), [search, filterEtape]);

  const selected = SITUATIONS.find(s => s.id === selectedId) || filtered[0] || null;

  function copier(text, key) {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(""), 2000);
  }

  const stats = {
    critique: SITUATIONS.filter(s => s.risque === "Critique").length,
    eleve:    SITUATIONS.filter(s => s.risque === "Élevé").length,
    moyen:    SITUATIONS.filter(s => s.risque === "Moyen").length,
  };

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", color: INK }}>

      {/* En-tête */}
      <div style={{ marginBottom: 24 }}><div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 4 }}>Entrée — Négociation</div><div style={{ fontSize: 24, fontWeight: 700 }}>Réponses Type & Objections</div><div style={{ fontSize: 13, color: INK_SOFT, marginTop: 3 }}>
          Arsenal de réponses YOMA pour protéger le cadre contractuel face aux objections clients
        </div></div>

      {/* KPIs */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 20, maxWidth: 500 }}>
        {[
          { label: "Situations critiques", value: stats.critique, ...RISQUE_CONFIG.Critique },
          { label: "Risque élevé",          value: stats.eleve,    ...RISQUE_CONFIG.Élevé    },
          { label: "Risque moyen",           value: stats.moyen,    ...RISQUE_CONFIG.Moyen    },
        ].map((k, i) => (
          <div key={i} style={{ background: k.bg, border: `1px solid ${k.border}`, borderRadius: 10, padding: "14px 16px" }}><div style={{ fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase", color: k.color, fontWeight: 700, marginBottom: 4 }}>{k.label}</div><div style={{ fontSize: 22, fontWeight: 800, color: k.color }}>{k.value}</div></div>
        ))}
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}><input value={search} onChange={e => setSearch(e.target.value)}
          placeholder=" Rechercher une situation..."
          style={{ flex: 1, minWidth: 220, padding: "9px 12px", border: `1px solid ${BORDER}`, borderRadius: 8, fontSize: 13, color: INK, background: WHITE, outline: "none" }} /><select value={filterEtape} onChange={e => { setFilterEtape(e.target.value); const f = e.target.value === "toutes" ? SITUATIONS[0] : SITUATIONS.find(s => s.etape === e.target.value); if (f) setSelectedId(f.id); }}
          style={{ padding: "9px 12px", border: `1px solid ${BORDER}`, borderRadius: 8, fontSize: 13, color: INK, background: WHITE, outline: "none" }}><option value="toutes">Toutes les étapes</option>
          {etapes.map(e => <option key={e} value={e}>{e}</option>)}
        </select></div><div style={{ display: "grid", gridTemplateColumns: "320px 1fr", gap: 16, alignItems: "start" }}>

        {/* ── Liste situations ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {filtered.length === 0 ? (
            <div style={{ padding: 24, textAlign: "center", color: "#bbb", fontSize: 12, fontStyle: "italic" }}>Aucune situation trouvée</div>
          ) : filtered.map(s => {
            const r = RISQUE_CONFIG[s.risque] || RISQUE_CONFIG.Moyen;
            const active = selected?.id === s.id;
            return (
              <div key={s.id} onClick={() => setSelectedId(s.id)}
                style={{ background: WHITE, border: active ? `2px solid ${GOLD}` : `1px solid ${BORDER}`, borderRadius: 10, padding: "12px 14px", cursor: "pointer", transition: "all 0.15s", borderLeft: active ? `4px solid ${GOLD}` : `4px solid ${r.color}` }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.08)"; }}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
              ><div style={{ fontWeight: 700, fontSize: 13, marginBottom: 5, color: INK }}>{s.titre}</div><div style={{ fontSize: 11, color: INK_SOFT, marginBottom: 6 }}>{s.etape}</div><span style={{ background: r.bg, color: r.color, border: `1px solid ${r.border}`, borderRadius: 999, padding: "2px 10px", fontSize: 10, fontWeight: 700 }}>
                  {r.icon} {s.risque}
                </span></div>
            );
          })}
        </div>

        {/* ── Détail ── */}
        {selected ? (() => {
          const r = RISQUE_CONFIG[selected.risque] || RISQUE_CONFIG.Moyen;
          return (
            <div>
              {/* Header */}
              <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "20px 24px", marginBottom: 14, borderTop: `4px solid ${r.color}` }}><div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}><div style={{ fontSize: 18, fontWeight: 700, color: INK, flex: 1, lineHeight: 1.3 }}>{selected.titre}</div><span style={{ background: r.bg, color: r.color, border: `1px solid ${r.border}`, borderRadius: 999, padding: "5px 14px", fontSize: 11, fontWeight: 700, marginLeft: 12, whiteSpace: "nowrap" }}>
                    {r.icon} Risque {selected.risque}
                  </span></div><div style={{ fontSize: 11, color: INK_SOFT }}><span style={{ fontWeight: 600 }}>Étape :</span> {selected.etape}
                </div></div>

              {/* Principe */}
              <div style={{ background: SOFT_BG, border: `1px solid ${BORDER}`, borderRadius: 10, padding: "14px 18px", marginBottom: 14 }}><div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: INK_SOFT, fontWeight: 700, marginBottom: 6 }}>Principe structurel</div><div style={{ fontSize: 13, color: INK, fontStyle: "italic", lineHeight: 1.6 }}>"{selected.principe}"</div></div>

              {/* Réponse type */}
              <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 10, padding: "16px 18px", marginBottom: 14, borderLeft: `4px solid ${GOLD}` }}><div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}><div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: GOLD, fontWeight: 700 }}>Réponse type</div><button onClick={() => copier(selected.reponseCourte, "reponse")}
                    style={{ padding: "4px 12px", background: copied === "reponse" ? "#E8F6EF" : SOFT_BG, color: copied === "reponse" ? "#1A7A44" : INK_SOFT, border: `1px solid ${BORDER}`, borderRadius: 6, fontSize: 11, cursor: "pointer", fontWeight: 600 }}>
                    {copied === "reponse" ? "✓ Copié" : " Copier"}
                  </button></div><div style={{ fontSize: 13, color: INK, lineHeight: 1.7 }}>{selected.reponseCourte}</div></div>

              {/* Si insiste */}
              <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 10, padding: "16px 18px", marginBottom: 14, borderLeft: "4px solid #95A5A6" }}><div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}><div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: INK_SOFT, fontWeight: 700 }}>Si le client insiste</div><button onClick={() => copier(selected.siInsiste, "insiste")}
                    style={{ padding: "4px 12px", background: copied === "insiste" ? "#E8F6EF" : SOFT_BG, color: copied === "insiste" ? "#1A7A44" : INK_SOFT, border: `1px solid ${BORDER}`, borderRadius: 6, fontSize: 11, cursor: "pointer", fontWeight: 600 }}>
                    {copied === "insiste" ? "✓ Copié" : " Copier"}
                  </button></div><div style={{ fontSize: 13, color: INK, lineHeight: 1.7 }}>{selected.siInsiste}</div></div>

              {/* Ne jamais dire */}
              <div style={{ background: "#FDEDEC", border: "1px solid #F2C4C0", borderRadius: 10, padding: "16px 18px", marginBottom: 14 }}><div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: "#C0392B", fontWeight: 700, marginBottom: 10 }}>
                   Ce qu'on ne dit JAMAIS
                </div><div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {selected.neJamaisDire.map((t, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: "#C0392B" }}><span style={{ fontWeight: 700, flexShrink: 0 }}>×</span><span style={{ textDecoration: "line-through", opacity: 0.8 }}>"{t}"</span></div>
                  ))}
                </div></div>

              {/* Rappel YOMA */}
              <div style={{ background: "#FEF9EE", border: "1px solid #F0DEB4", borderRadius: 10, padding: "14px 18px" }}><div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: GOLD, fontWeight: 700, marginBottom: 6 }}>
                   Rappel YOMA
                </div><div style={{ fontSize: 13, color: INK, lineHeight: 1.6 }}>
                  La fermeté à l'entrée protège la marge, le cadre contractuel et la qualité du projet. Céder sur le cadre, c'est accepter un projet mal positionné dès le départ.
                </div></div></div>
          );
        })() : (
          <div style={{ padding: 48, textAlign: "center", color: "#bbb", fontSize: 13, fontStyle: "italic" }}>
            Sélectionnez une situation
          </div>
        )}
      </div></div>
  );
}